<template>
  <div>
    <section>
    </section>
    <div class="fixed_height">
      <div class="container-fluid top_header">
        <div class="container_menu_inside py-1">
          <a href="http://www.odido.nl" target="_blank">Naar Odido.nl</a>
        </div>
      </div>

      <div class="container-fluid menu" :class="(hasAccessToken) ? 'logged_in': ''">
        <div class="container py-lg-3 py-md-2 py-0">
          <div class="d-flex flex-row align-items-center my-0 my-lg-0">

            <img src="./../assets/img/millen_images/logo.svg" @click="goToHome" class="logo">
            <a @click="goToHowItWorks" class="desktop">Zo werkt het</a>
            <a @click="goToWinners" class="desktop">Winnaars</a>
            <a @click="topUpNow" class="desktop">Nu opwaarderen</a>
            <a @click="bundleNow" class="desktop">Koop een bundel</a>
            <a @click="goToFAQ" class="desktop">Veelgestelde vragen</a>
            <!-- </div> -->

            <div v-if="!hasAccessToken"
                 class="d-flex flex-lg-row justify-content-end ml-auto account flex-column align-items-center">
              <img src="./../assets/img/header/profile_icon.svg" alt="">
              <a @click="goToLogin">Mijn Account</a>
            </div>

            <div v-if="hasAccessToken"
                 class="d-flex flex-lg-row flex-md-row justify-content-end ml-auto account flex-column align-items-center">
              <div class="d-flex flex-column flex-lg-row mr-md-3 align-items-center" @click="goToAccount">
                <div class="notifications">
                  <div v-if="getSumOfOpenActions>0" class="notification_icon">
                    <span>{{ getSumOfOpenActions }}</span>
                  </div>
                  <img src="./../assets/img/header/profile_icon.svg" alt="">
                </div>
                <p href="#" class="msisdn">{{ this.getMsisdn }}</p>
              </div>
              <a href="" @click="logOut" class="logout d-none d-lg-block d-md-block d-sm-none"  :style=" !this.mobileOrTablet ? 'display: block !important;' : ''">Logout</a>
            </div>

            <div class="nav_border mobile"></div>
            <div class="d-flex flex-column align-items-center mobile">
              <div class="nav-icon toggle-menu d-flex flex-column">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </div>
              <p>Menu</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="menu_mob">
      <nav class="main-nav mobile">
        <ul>
          <li>
            <a @click="goToHowItWorks">Zo werkt het</a>
          </li>
          <li>
            <a @click="goToWinners">Winnaars</a>
          </li>
          <li>
            <a @click="topUpNow">Nu opwaarderen</a>
          </li>
          <li>
            <a @click="bundleNow">Koop een bundel</a>
          </li>
          <li>
            <a @click="goToFAQ">Veelgestelde vragen</a>
          </li>
          <li v-if="hasAccessToken">
            <a href="" @click="logOut">Logout</a>
          </li>
        </ul>
      </nav>
    </div>

    <login-popup v-if="loginModalOpen"></login-popup>
    <register-popup v-if="registerModalOpen"></register-popup>
    <forgot-password-popup v-if="forgotPasswordModalOpen"></forgot-password-popup>
    <cookies-popup></cookies-popup>
  </div>
</template>

<script>
  import router from '../router'
  import Login from './modals/Login'
  import Register from './modals/Register'
  import ForgotPassword from './modals/ForgotPassword'
  import Cookies from './modals/Cookies'
  import {mapActions, mapGetters, mapMutations} from 'vuex'
  import {isMobile, isTablet} from 'mobile-device-detect'
  import gameFlow from '../common/mixin/gameFlow'
  import gtm_analytics from "../common/mixin/gtm_analytics";

  export default {
    name: 'Header',
    components: {
      'login-popup': Login,
      'register-popup': Register,
      'forgot-password-popup': ForgotPassword,
      'cookies-popup': Cookies
    },
    mixins: [
      gameFlow,
      gtm_analytics
    ],
    data() {
      return {
        mobileOrTablet: false
      }
    },
    computed: {
      ...mapGetters([
        'isLoginModalOpen',
        'getAccessToken',
        'isRegisterModalOpen',
        'isForgotPasswordModalOpen',
        'getMsisdn',
        'getSumOfOpenActions',
        'getAccountResponse',
        'getInGameFlow',
        'getRedemptionMsisdn',
        'getSelectedCodeForRedemption'
      ]),
      hasAccessToken() {
        return (this.getAccessToken) ? true : false
      },

      loginModalOpen() {
        return this.isLoginModalOpen
      },
      registerModalOpen() {
        return this.isRegisterModalOpen
      },
      forgotPasswordModalOpen() {
        return this.isForgotPasswordModalOpen
      }
    },
    mounted() {
      this.mobileOrTablet = isMobile || isTablet
      if (this.getAccessToken) {
        this.loadMyAccount()
          .then(() => {
            const pendingCodesLength = (this.getAccountResponse.pendingCodes !== null) ? this.getAccountResponse.pendingCodes.length : 0
            const unfinishedTelcoCodesLength = (this.getAccountResponse.unfinishedTelcoCodes !== null) ? this.getAccountResponse.unfinishedTelcoCodes.length : 0
            const unfinishedPhysicalCodesLength = (this.getAccountResponse.unfinishedPhysicalCodes !== null) ? this.getAccountResponse.unfinishedPhysicalCodes.length : 0
            this.updateSumOfOpenActions(pendingCodesLength + unfinishedTelcoCodesLength + unfinishedPhysicalCodesLength)
          })
      }
      if (this.getInGameFlow === "true"
        && this.getRedemptionMsisdn !== null
        && this.getSelectedCodeForRedemption !== null) {
        this.loadConversation()
          .then((response) => {
            this.loadInfoFromConversation(response)
          })
      }
    },
    methods: {
      ...mapMutations([
        'updateLoginModal',
        'updateAccessToken',
        'updateRegisterModal',
        'updateSumOfOpenActions'
      ]),
      ...mapActions([
        'loadMyAccount',
        'loadConversation'
      ]),
      closeNavBar() {
        if (this.mobileOrTablet) {
          $('.toggle-menu').removeClass('open active')
          $('.menu_mob').removeClass('open')
        }
      },
      goToHome() {
        this.closeNavBar()
        this.checkIfUserIntoGameFlow()
        router.push({name: 'Home'}).catch(() => {
        });
      },
      goToHowItWorks() {
        this.closeNavBar()
        this.checkIfUserIntoGameFlow()
        router.push({name: 'HowItWorks'}).catch(() => {
        });
      },
      topUpNow() {
        this.closeNavBar()
        window.open('https://opwaarderen.odido.nl', '_blank')
      },
      bundleNow() {
        this.closeNavBar()
        window.open('https://www.odido.nl/mobiel/prepaid/bundels', '_blank')
      },
      goToWinners() {
        this.closeNavBar()
        this.checkIfUserIntoGameFlow()
        router.push({name: 'Winners'}).catch(() => {
        });
      },
      goToFAQ() {
        this.closeNavBar()
        this.checkIfUserIntoGameFlow()
        router.push({name: 'Faq'}).catch(() => {
        });
      },
      goToAccount() {
        this.closeNavBar()
        router.push({name: 'Account'}).catch(() => {
        });
      },
      goToLogin() {
        this.closeNavBar()
        if (this.getAccessToken === null && this.$route.name.includes("Home")) {
          const element = document.getElementById('login_section')
          const headerOffset = 170;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.scrollY - headerOffset;
          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          })
        } else {
          this.updateLoginModal(true)
        }
      },
      logOut() {
        this.closeNavBar()
        this.updateAccessToken(null)
        localStorage.removeItem('accessToken');
        router.push({name: 'Home'}).catch(() => {
        });
      },
      checkIfUserIntoGameFlow() {
        if (this.getInGameFlow) {
          this.resetGameState()
        }
      }

    }
  }
</script>

<style scoped>
  a, .msisdn:hover {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue